import React, { useEffect, useState } from 'react'
import ParticipantDashboardNavWidget from '../../../components/widgets/ParticipantDashboardNavWidget';
import UserAcademyCourses from '../../../components/widgets/UserAcademyCourses';
import { useStateValue } from '../../../StateProvider';
import { getDefaultValue } from '../../../utils';
import { loadCourses, loadUserTalents } from '../../../utils/Network';
import {
  collectUserTalentAncestorIds,
  courseIsStaffPreview,
  getCourseTalentIds,
} from '../../../utils/contestEligibility';

export default function DashboardAside({ showAsideMenu = false }) {

  const [courses, setCourses] = useState(null);
  const [role, setRole] = useState("participant");

  const [{ translations }] = useStateValue();
  const translate = (str) => {
    if (!translations) return str;
    var translate = translations.find(x => x.key == str);

    if (translate) return getDefaultValue(translate);
    else return "#" + str;
  };

  useEffect(() => {
    _getData();
  }, []);

  const _getData = () => {
    Promise.all([
      loadCourses({ size: 500 }),
      loadUserTalents({ size: 500 }),
    ])
      .then(([coursesList, userTalents]) => {
        const courses = coursesList || [];
        const userTalentIdSet = collectUserTalentAncestorIds(userTalents || []);
        const filtered = courses.filter((course) => {
          const contestIds = getCourseTalentIds(course);
          if (!contestIds.length) return false;
          if (courseIsStaffPreview(course)) return true;
          return contestIds.some((tid) => userTalentIdSet.has(tid));
        });
        setCourses(filtered);
      })
      .catch(() => setCourses([]));
  }

  return (
    <div className="col-lg-3 mt-4 mt-lg-0 hide-on-small participant-dashboard-sidebar">
      {showAsideMenu ? (
        <ParticipantDashboardNavWidget
        translate={translate}
        courses={courses}
        role={role}
        />
      ) : null}
      <div className="participant-dashboard-academy kfont lan-text-right">
        <UserAcademyCourses translate={translate} />
      </div>
    </div>

  )

}
